module.exports = __webpack_public_path__ + "static/media/diarmuid.e6147d0f.png";